import type { SelfEmployedPayoutMethod } from '@/shared/api'

/** Пустая форма. `bank_id: 0` — банк ещё не выбран: в типе API id обязателен. */
export const EMPTY_PAYOUT_METHOD: SelfEmployedPayoutMethod = {
    bank_id: 0,
    bank_name: '',
    bank_icon_url: null,
    email: '',
    method: 'sbp',
    phone: '',
}
